// MARK://dhk8/admin-shell/lib/queries/reports
// Queries tipadas de reportes — F2.6 / ADR-0009. El Admin lee los read-models del
// negocio por el grafo (erp-reports), tenant del JWT. Reportes son read-only.
import { graphql } from '../../gql/index.js'

// KPIs del landing: ventas/órdenes/ticket prom (de reportSales) + propinas (reportTips).
export const AdminReportSummaryQuery = graphql(`
  query AdminReportSummary($from: String, $to: String) {
    reportSales(from: $from, to: $to) {
      totals { ordersCount netCents grossCents avgTicketCents tipsCents }
    }
    reportTips(from: $from, to: $to) {
      totals { totalCents }
    }
    reportTaxes(from: $from, to: $to) {
      subtotalCents
      taxCents
      totalCents
    }
    reportPaymentMethods(from: $from, to: $to) {
      method
      count
      amountCents
    }
    reportVoidsDiscounts(from: $from, to: $to) {
      cancelledCount
      cancelledCents
      discountedOrders
      discountCents
    }
  }
`)

// Comparativo: del periodo ANTERIOR solo necesitamos los totales de ventas.
export const AdminReportPrevSalesQuery = graphql(`
  query AdminReportPrevSales($from: String, $to: String) {
    reportSales(from: $from, to: $to) {
      totals { ordersCount netCents }
    }
  }
`)

export const AdminReportSalesQuery = graphql(`
  query AdminReportSales($from: String, $to: String) {
    reportSales(from: $from, to: $to) {
      rows { businessDate ordersCount grossCents netCents tipsCents }
      totals { ordersCount grossCents netCents tipsCents }
    }
  }
`)

export const AdminReportTopProductsQuery = graphql(`
  query AdminReportTopProducts($from: String, $to: String, $limit: Int) {
    reportTopProducts(from: $from, to: $to, limit: $limit) {
      productName
      qty
      grossCents
    }
  }
`)

export const AdminReportTopServersQuery = graphql(`
  query AdminReportTopServers($from: String, $to: String, $limit: Int) {
    reportTopServers(from: $from, to: $to, limit: $limit) {
      serverName
      ordersCount
      grossCents
      tipsCents
    }
  }
`)

// Reconstruye los read-models de reports desde la fuente (PosOrder CLOSED) — acción
// pesada gated por `erp-reports:report:rebuild@*`. IDEMPOTENTE (clear-range + re-proyección).
export const RebuildReportProjectionsMutation = graphql(`
  mutation AdminRebuildReportProjections($from: String, $to: String, $branchId: String) {
    rebuildReportProjections(from: $from, to: $to, branchId: $branchId) {
      ordersReprocessed
      tablesAffected
      from
      to
    }
  }
`)

export const AdminReportCutsQuery = graphql(`
  query AdminReportCuts($from: String, $to: String, $limit: Int) {
    reportCuts(from: $from, to: $to, limit: $limit) {
      businessDate
      branchId
      kind
      expectedCents
      countedCents
      varianceCents
    }
  }
`)
